





























































































































































































































































































































































































































































import mixins from 'vue-typed-mixins'
import { UnitValuationStepData } from '@/interfaces/valuation/ValuationData'
import valuationStepMixin from '@/mixins/valuation/valuationStep'
import { PropertyType } from '@/interfaces/valuation/types/PropertyValuationStep'
import * as types from '@/interfaces/valuation/types/UnitValuationStep'
import { VMoney } from 'v-money'

export default mixins(valuationStepMixin).extend({
  directives: {
    money: VMoney,
  },
  data(): { stepData: UnitValuationStepData } {
    return {
      stepData: {
        unit: {
          houseNumber: '',
          houseStatus: types.HouseStatus.State1,
          houseLayout: 1,
          houseLocation: types.HouseLocation.Single,
          houseSpecification: types.HouseSpecification.Standard,
          houseSize: types.HouseSize.Single,
          houseHeating: types.HouseHeating.Electric,
          houseCellar: false,
        },
        propertyPrice: 0,
      },
    }
  },
  computed: {
    moneyFormat() {
      return {
        precision: 0,
        thousands: ' ',
        decimal: ',',
      }
    },
  },
})
